import { useState, useEffect } from 'react';
import { Star, Clock, Users, MapPin, Heart, Filter, Grid, List, X, SlidersHorizontal } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import Button from '../../components/base/Button';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

interface Activity {
  id: number;
  title: string;
  location: string;
  price: string;
  originalPrice: string;
  duration: string;
  groupSize: string;
  rating: number;
  reviews: number;
  image: string;
  badge: string;
  category: string;
  highlights: string[];
  urgent?: string;
}

const allActivities: Activity[] = [
  {
    id: 1,
    title: "Safari dans le Désert Premium",
    location: "Désert Al Madam",
    price: "55.66",
    originalPrice: "75.00",
    duration: "6 heures",
    groupSize: "Jusqu'à 8 personnes",
    rating: 4.9,
    reviews: 2847,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/safari-dubai-desert-.jpg.webp",
    badge: "Bestseller",
    category: "Aventure",
    highlights: ["Dîner bédouin", "Spectacle de danse", "Balade en chameau", "Photos professionnelles"],
    urgent: "Plus que 3 places aujourd'hui"
  },
  {
    id: 2,
    title: "Burj Khalifa + Aquarium",
    location: "Downtown Dubai",
    price: "45.98",
    originalPrice: "65.00",
    duration: "4 heures",
    groupSize: "Accès immédiat",
    rating: 4.8,
    reviews: 1923,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/ce21d131464d69f89d14ea294961b6f00dc75489-1.jpg.webp",
    badge: "Coupe-file",
    category: "Culture",
    highlights: ["Étage 124 & 125", "Aquarium géant", "Tunnel sous-marin", "Audio guide français"],
    urgent: "Réservation recommandée"
  },
  {
    id: 3,
    title: "Petit-déjeuner avec Girafes",
    location: "Abu Dhabi",
    price: "508.20",
    originalPrice: "580.00",
    duration: "3 heures",
    groupSize: "Session de 4 personnes",
    rating: 5.0,
    reviews: 456,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2023/08/breakfast-with-the-girrafe-dinner-with-elephant-dubai-holidays-vacances-a-dubai.jpeg",
    badge: "Exclusif",
    category: "Luxe",
    highlights: ["Expérience unique", "Petit-déjeuner gourmet", "Photos incluses", "Transport privé"],
    urgent: "Disponibilité limitée"
  },
  {
    id: 4,
    title: "Aquaventure Waterpark",
    location: "Palm Jumeirah",
    price: "79.86",
    originalPrice: "95.00",
    duration: "Journée complète",
    groupSize: "Accès illimité",
    rating: 4.7,
    reviews: 3241,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/aquaventure-.jpg.webp",
    badge: "Famille",
    category: "Famille",
    highlights: ["Toboggans géants", "Plage privée", "Aquarium", "Restaurants inclus"],
    urgent: "Offre spéciale weekend"
  },
  {
    id: 5,
    title: "Jetski & Flyboard",
    location: "Dubai Marina",
    price: "84.70",
    originalPrice: "110.00",
    duration: "2 heures",
    groupSize: "1-2 personnes",
    rating: 4.9,
    reviews: 892,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/11/jetski-3.jpg",
    badge: "Aventure",
    category: "Aventure",
    highlights: ["Jetski 30min", "Flyboard 15min", "Équipement inclus", "Instructeur français"],
    urgent: "Météo parfaite"
  },
  {
    id: 6,
    title: "Croisière Musandam",
    location: "Oman",
    price: "145.20",
    originalPrice: "180.00",
    duration: "Journée complète",
    groupSize: "Groupe",
    rating: 4.8,
    reviews: 1567,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/musandam-cruise-.jpg.webp",
    badge: "Nature",
    category: "Nature",
    highlights: ["Fjords d'Arabie", "Déjeuner à bord", "Snorkeling", "Dauphins"],
    urgent: "Départ garanti"
  },
  {
    id: 7,
    title: "Vol en Hélicoptère Dubai",
    location: "Dubai Marina",
    price: "245.00",
    originalPrice: "295.00",
    duration: "25 minutes",
    groupSize: "1-3 personnes",
    rating: 5.0,
    reviews: 623,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/11/jetski-3.jpg",
    badge: "Luxe",
    category: "Luxe",
    highlights: ["Vue panoramique", "Palm Jumeirah", "Burj Al Arab", "Photos incluses"],
    urgent: "Réservation 48h à l'avance"
  },
  {
    id: 8,
    title: "Dubai Frame + Musée du Futur",
    location: "Downtown Dubai",
    price: "38.50",
    originalPrice: "52.00",
    duration: "3 heures",
    groupSize: "Accès immédiat",
    rating: 4.6,
    reviews: 1456,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/safari-dubai-desert-.jpg.webp",
    badge: "Culture",
    category: "Culture",
    highlights: ["Dubai Frame", "Musée du Futur", "Audio guide", "Vue 360°"],
    urgent: "Coupe-file inclus"
  },
  {
    id: 9,
    title: "Wild Wadi Waterpark",
    location: "Jumeirah",
    price: "72.30",
    originalPrice: "88.00",
    duration: "Journée complète",
    groupSize: "Famille",
    rating: 4.8,
    reviews: 2134,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2023/08/breakfast-with-the-girrafe-dinner-with-elephant-dubai-holidays-vacances-a-dubai.jpeg",
    badge: "Famille",
    category: "Famille",
    highlights: ["30 toboggans", "Plage artificielle", "Restaurants", "Zone enfants"],
    urgent: "Pack famille -20%"
  },
  {
    id: 10,
    title: "Plongée avec Requins",
    location: "Dubai Aquarium",
    price: "125.00",
    originalPrice: "150.00",
    duration: "2 heures",
    groupSize: "Petit groupe",
    rating: 4.9,
    reviews: 789,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/ce21d131464d69f89d14ea294961b6f00dc75489-1.jpg.webp",
    badge: "Aventure",
    category: "Aventure",
    highlights: ["Requins tigres", "Équipement fourni", "Photos sous-marine", "Instructeur certifié"],
    urgent: "Expérience unique"
  },
  {
    id: 11,
    title: "Dîner Croisière Dhow",
    location: "Dubai Creek",
    price: "68.90",
    originalPrice: "85.00",
    duration: "2 heures",
    groupSize: "Groupe",
    rating: 4.7,
    reviews: 1892,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/safari-dubai-desert-.jpg.webp",
    badge: "Culture",
    category: "Culture",
    highlights: ["Dîner buffet", "Spectacle traditionnel", "Vue sur la ville", "Boissons incluses"],
    urgent: "Départ quotidien"
  },
  {
    id: 12,
    title: "Observation Baleines & Dauphins",
    location: "Golfe Persique",
    price: "95.50",
    originalPrice: "120.00",
    duration: "4 heures",
    groupSize: "Petit groupe",
    rating: 4.8,
    reviews: 567,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/aquaventure-.jpg.webp",
    badge: "Nature",
    category: "Nature",
    highlights: ["Observation garantie", "Guide naturaliste", "Snack à bord", "Photos offertes"],
    urgent: "Saison optimale"
  },
  {
    id: 13,
    title: "Visite d'Abu Dhabi & Grande Mosquée",
    location: "Abu Dhabi",
    price: "62.92",
    originalPrice: "85.00",
    duration: "Journée complète",
    groupSize: "Groupe",
    rating: 4.8,
    reviews: 1234,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/ce21d131464d69f89d14ea294961b6f00dc75489-1.jpg.webp",
    badge: "Culture",
    category: "Culture",
    highlights: ["Grande Mosquée", "Palais présidentiel", "Déjeuner inclus", "Guide français"]
  },
  {
    id: 14,
    title: "Parc Animalier Sauvage",
    location: "Dubai",
    price: "242.00",
    originalPrice: "280.00",
    duration: "4 heures",
    groupSize: "Petit groupe",
    rating: 4.9,
    reviews: 456,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/safari-dubai-desert-.jpg.webp",
    badge: "Nature",
    category: "Nature",
    highlights: ["Rencontre avec animaux", "Safari guidé", "Photos incluses", "Transport privé"]
  },
  {
    id: 15,
    title: "Sonara Camp",
    location: "Désert de Dubaï",
    price: "130.68",
    originalPrice: "160.00",
    duration: "Soirée",
    groupSize: "Groupe",
    rating: 4.9,
    reviews: 789,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/safari-dubai-desert-.jpg.webp",
    badge: "Luxe",
    category: "Luxe",
    highlights: ["Dîner gastronomique", "Camp de luxe", "Spectacle étoiles", "Bar à ciel ouvert"]
  },
  {
    id: 16,
    title: "Croisière Dînatoire Dubai Marina",
    location: "Dubai Marina",
    price: "62.92",
    originalPrice: "80.00",
    duration: "2 heures",
    groupSize: "Groupe",
    rating: 4.7,
    reviews: 2156,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/musandam-cruise-.jpg.webp",
    badge: "Culture",
    category: "Culture",
    highlights: ["Dîner buffet", "Vue sur Marina", "Boissons incluses", "Départ quotidien"]
  },
  {
    id: 17,
    title: "Visite Guidée du Vieux Dubai",
    location: "Dubai Creek",
    price: "36.30",
    originalPrice: "50.00",
    duration: "3 heures",
    groupSize: "Groupe",
    rating: 4.6,
    reviews: 892,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/ce21d131464d69f89d14ea294961b6f00dc75489-1.jpg.webp",
    badge: "Culture",
    category: "Culture",
    highlights: ["Souk de l'or", "Dubai Museum", "Traversée en abra", "Guide francophone"]
  },
  {
    id: 18,
    title: "Tour de Jetcar",
    location: "Dubai Marina",
    price: "193.60",
    originalPrice: "240.00",
    duration: "30 minutes",
    groupSize: "1-2 personnes",
    rating: 5.0,
    reviews: 234,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/11/jetski-3.jpg",
    badge: "Aventure",
    category: "Aventure",
    highlights: ["Expérience unique", "Instructeur certifié", "Photos incluses", "Équipement fourni"]
  },
  {
    id: 19,
    title: "Location de Yachts Privés",
    location: "Dubai Marina",
    price: "254.10",
    originalPrice: "300.00",
    duration: "2-4 heures",
    groupSize: "Jusqu'à 12 personnes",
    rating: 4.9,
    reviews: 567,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/musandam-cruise-.jpg.webp",
    badge: "Luxe",
    category: "Luxe",
    highlights: ["Yacht privé", "Skipper inclus", "Snacks & boissons", "Personnalisable"]
  },
  {
    id: 20,
    title: "Dubai City Tour",
    location: "Dubai",
    price: "284.35",
    originalPrice: "350.00",
    duration: "Journée complète",
    groupSize: "Petit groupe",
    rating: 4.8,
    reviews: 1234,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/ce21d131464d69f89d14ea294961b6f00dc75489-1.jpg.webp",
    badge: "Culture",
    category: "Culture",
    highlights: ["Tous les monuments", "Déjeuner inclus", "Guide privé", "Transport VIP"]
  },
  {
    id: 21,
    title: "Soirée Yacht Party",
    location: "Dubai Marina",
    price: "87.12",
    originalPrice: "110.00",
    duration: "3 heures",
    groupSize: "Groupe",
    rating: 4.7,
    reviews: 892,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/musandam-cruise-.jpg.webp",
    badge: "Culture",
    category: "Culture",
    highlights: ["DJ à bord", "Bar ouvert", "Snacks inclus", "Ambiance festive"]
  },
  {
    id: 22,
    title: "Saadiyat Beach Club",
    location: "Abu Dhabi",
    price: "54.45",
    originalPrice: "70.00",
    duration: "Journée complète",
    groupSize: "Accès illimité",
    rating: 4.8,
    reviews: 456,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/aquaventure-.jpg.webp",
    badge: "Famille",
    category: "Famille",
    highlights: ["Plage privée", "Piscine", "Restaurants", "Transats inclus"]
  },
  {
    id: 23,
    title: "Nurai Island",
    location: "Abu Dhabi",
    price: "133.10",
    originalPrice: "160.00",
    duration: "Journée complète",
    groupSize: "Accès illimité",
    rating: 4.9,
    reviews: 678,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/aquaventure-.jpg.webp",
    badge: "Luxe",
    category: "Luxe",
    highlights: ["Île privée", "Plage exclusive", "Restaurants", "Spa disponible"]
  },
  {
    id: 24,
    title: "Dîner avec les Éléphants",
    location: "Dubai",
    price: "63.53",
    originalPrice: "80.00",
    duration: "2 heures",
    groupSize: "Petit groupe",
    rating: 4.8,
    reviews: 345,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2023/08/breakfast-with-the-girrafe-dinner-with-elephant-dubai-holidays-vacances-a-dubai.jpeg",
    badge: "Exclusif",
    category: "Luxe",
    highlights: ["Expérience unique", "Dîner gourmet", "Photos incluses", "Interaction avec éléphants"]
  },
  {
    id: 25,
    title: "Saut en Parachute Palm Jumeirah",
    location: "Palm Jumeirah",
    price: "665.26",
    originalPrice: "750.00",
    duration: "30 minutes",
    groupSize: "1 personne",
    rating: 5.0,
    reviews: 234,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/safari-dubai-desert-.jpg.webp",
    badge: "Aventure",
    category: "Aventure",
    highlights: ["Vue panoramique", "Instructeur tandem", "Vidéo HD incluse", "Certificat souvenir"]
  },
  {
    id: 26,
    title: "Musée du Futur",
    location: "Dubai",
    price: "41.14",
    originalPrice: "55.00",
    duration: "2 heures",
    groupSize: "Accès immédiat",
    rating: 4.9,
    reviews: 3456,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/ce21d131464d69f89d14ea294961b6f00dc75489-1.jpg.webp",
    badge: "Culture",
    category: "Culture",
    highlights: ["Architecture unique", "Expositions interactives", "Audio guide", "Coupe-file"]
  },
  {
    id: 27,
    title: "Dubai Frame",
    location: "Dubai",
    price: "14.52",
    originalPrice: "20.00",
    duration: "1 heure",
    groupSize: "Accès immédiat",
    rating: 4.5,
    reviews: 2134,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/ce21d131464d69f89d14ea294961b6f00dc75489-1.jpg.webp",
    badge: "Culture",
    category: "Culture",
    highlights: ["Vue panoramique", "Pont vitré", "Musée interactif", "Photos illimitées"]
  },
  {
    id: 28,
    title: "IMG Worlds of Adventure",
    location: "Dubai",
    price: "83.49",
    originalPrice: "100.00",
    duration: "Journée complète",
    groupSize: "Famille",
    rating: 4.7,
    reviews: 1892,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/aquaventure-.jpg.webp",
    badge: "Famille",
    category: "Famille",
    highlights: ["Parc à thème Marvel", "Attractions intérieures", "Restaurants", "Zone enfants"]
  }
];

export default function ActivitiesPage() {
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') || '';
  
  const [activeFilter, setActiveFilter] = useState<string>('Tous');
  const [favorites, setFavorites] = useState<number[]>([]);
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [sortBy, setSortBy] = useState<string>('popular');
  const [priceRange, setPriceRange] = useState<string>('all');
  const [showFilters, setShowFilters] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [minRating, setMinRating] = useState<number>(0);
  const [minPrice, setMinPrice] = useState<number>(0);
  const [maxPrice, setMaxPrice] = useState<number>(1000);

  // Advanced filtering
  let filteredActivities = allActivities;

  // Search filter
  if (searchQuery.trim()) {
    const query = searchQuery.toLowerCase();
    filteredActivities = filteredActivities.filter(activity => 
      activity.title.toLowerCase().includes(query) ||
      activity.location.toLowerCase().includes(query) ||
      activity.category.toLowerCase().includes(query) ||
      activity.highlights.some(h => h.toLowerCase().includes(query)) ||
      activity.badge.toLowerCase().includes(query)
    );
  }

  // Category filter
  if (activeFilter !== 'Tous') {
    filteredActivities = filteredActivities.filter(activity => activity.category === activeFilter);
  }

  // Multiple categories filter
  if (selectedCategories.length > 0) {
    filteredActivities = filteredActivities.filter(activity => 
      selectedCategories.includes(activity.category)
    );
  }

  // Price range filter (old method)
  if (priceRange !== 'all') {
    filteredActivities = filteredActivities.filter(activity => {
      const activityPrice = parseFloat(activity.price);
      switch (priceRange) {
        case '0-96.80':
          return activityPrice <= 96.80;
        case '97.04-193.60':
          return activityPrice >= 97.04 && activityPrice <= 193.60;
        case '193.84+':
          return activityPrice >= 193.84;
        default:
          return true;
      }
    });
  }

  // Advanced price filter (slider)
  filteredActivities = filteredActivities.filter(activity => {
    const activityPrice = parseFloat(activity.price);
    return activityPrice >= minPrice && activityPrice <= maxPrice;
  });

  // Rating filter
  if (minRating > 0) {
    filteredActivities = filteredActivities.filter(activity => activity.rating >= minRating);
  }

  const sortedActivities = [...filteredActivities].sort((a, b) => {
    switch (sortBy) {
      case 'price-asc':
        return parseFloat(a.price) - parseFloat(b.price);
      case 'price-desc':
        return parseFloat(b.price) - parseFloat(a.price);
      case 'rating':
        return b.rating - a.rating;
      default:
        return b.reviews - a.reviews;
    }
  });

  const toggleFavorite = (id: number) => {
    setFavorites(prev => 
      prev.includes(id) 
        ? prev.filter(fav => fav !== id)
        : [...prev, id]
    );
  };

  const toggleCategory = (category: string) => {
    setSelectedCategories(prev => 
      prev.includes(category)
        ? prev.filter(cat => cat !== category)
        : [...prev, category]
    );
  };

  const resetFilters = () => {
    setActiveFilter('Tous');
    setPriceRange('all');
    setSelectedCategories([]);
    setMinRating(0);
    setMinPrice(0);
    setMaxPrice(1000);
  };

  const activeFiltersCount = 
    (activeFilter !== 'Tous' ? 1 : 0) +
    (priceRange !== 'all' ? 1 : 0) +
    selectedCategories.length +
    (minRating > 0 ? 1 : 0) +
    (minPrice > 0 || maxPrice < 1000 ? 1 : 0);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-6 pb-8 bg-gradient-to-r from-blue-600 to-indigo-600 text-white relative">
        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <h1 className="text-4xl lg:text-5xl font-bold mb-2">Toutes Nos Activités</h1>
          <p className="text-lg text-blue-50 max-w-2xl">Découvrez plus de 50 activités testées et approuvées par notre équipe</p>
        </div>
      </section>

      {/* Filters and Controls */}
      <section className="py-6 bg-white border-b border-gray-200 sticky top-0 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-4">
            <h2 className="text-2xl font-bold text-gray-900">TYPE D'ACTIVITÉS</h2>
            
            {/* Quick Actions */}
            <div className="flex items-center gap-3">
              <button
                onClick={() => setShowFilters(!showFilters)}
                className="flex items-center gap-2 px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors"
              >
                <SlidersHorizontal size={18} />
                <span>Filtres avancés</span>
                {activeFiltersCount > 0 && (
                  <span className="bg-white text-amber-600 rounded-full px-2 py-0.5 text-xs font-bold">
                    {activeFiltersCount}
                  </span>
                )}
              </button>
              
              {activeFiltersCount > 0 && (
                <button
                  onClick={resetFilters}
                  className="flex items-center gap-2 px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <X size={18} />
                  <span>Réinitialiser</span>
                </button>
              )}

              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
              >
                <option value="popular">Plus populaires</option>
                <option value="rating">Mieux notées</option>
                <option value="price-asc">Prix croissant</option>
                <option value="price-desc">Prix décroissant</option>
              </select>
              
              <div className="flex border border-gray-300 rounded-lg overflow-hidden">
                <button
                  onClick={() => setViewMode('grid')}
                  className={`p-2 ${viewMode === 'grid' ? 'bg-amber-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
                >
                  <Grid size={20} />
                </button>
                <button
                  onClick={() => setViewMode('list')}
                  className={`p-2 ${viewMode === 'list' ? 'bg-amber-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
                >
                  <List size={20} />
                </button>
              </div>
            </div>
          </div>

          {/* Quick Category Filters */}
          <div className="flex flex-wrap gap-3 mb-4">
            {['Tous', 'Aventure', 'Famille', 'Luxe', 'Culture', 'Nature'].map((filter) => (
              <button
                key={filter}
                onClick={() => {
                  setActiveFilter(filter);
                  if (filter !== 'Tous') {
                    setSelectedCategories([]);
                  }
                }}
                className={`px-6 py-2 rounded-full transition-all font-medium ${
                  activeFilter === filter
                    ? 'bg-amber-600 text-white shadow-lg' 
                    : 'bg-gray-100 text-gray-700 hover:bg-amber-50 border border-gray-200'
                }`}
              >
                {filter === 'Tous' ? 'Filter - All' : filter} {activeFilter === filter && `(${filteredActivities.length})`}
              </button>
            ))}
          </div>

          {/* Advanced Filters Panel */}
          {showFilters && (
            <div className="border-t border-gray-200 pt-6 mt-4 bg-gray-50 rounded-lg p-6">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Multiple Categories */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-3">
                    Catégories (plusieurs choix)
                  </label>
                  <div className="space-y-2">
                    {['Aventure', 'Famille', 'Luxe', 'Culture', 'Nature'].map((category) => (
                      <label key={category} className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedCategories.includes(category)}
                          onChange={() => toggleCategory(category)}
                          className="w-4 h-4 text-amber-600 border-gray-300 rounded focus:ring-amber-500"
                        />
                        <span className="text-sm text-gray-700">{category}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Price Range Slider */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-3">
                    Prix: {minPrice}€ - {maxPrice}€
                  </label>
                  <div className="space-y-3">
                    <div className="flex items-center gap-2">
                      <input
                        type="number"
                        value={minPrice}
                        onChange={(e) => setMinPrice(Number(e.target.value))}
                        className="w-24 px-3 py-2 border border-gray-300 rounded-lg text-sm"
                        placeholder="Min"
                      />
                      <span className="text-gray-500">-</span>
                      <input
                        type="number"
                        value={maxPrice}
                        onChange={(e) => setMaxPrice(Number(e.target.value))}
                        className="w-24 px-3 py-2 border border-gray-300 rounded-lg text-sm"
                        placeholder="Max"
                      />
                    </div>
                    <div className="flex gap-2">
                      {[0, 50, 100, 200, 500].map((price) => (
                        <button
                          key={price}
                          onClick={() => {
                            setMinPrice(price);
                            setMaxPrice(price === 500 ? 1000 : price + 100);
                          }}
                          className="px-3 py-1 text-xs bg-white border border-gray-300 rounded hover:bg-amber-50"
                        >
                          {price}€+
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Rating Filter */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-3">
                    Note minimale: {minRating > 0 ? `${minRating}+` : 'Toutes'}
                  </label>
                  <div className="flex items-center gap-2">
                    {[0, 4, 4.5, 4.8, 4.9].map((rating) => (
                      <button
                        key={rating}
                        onClick={() => setMinRating(rating)}
                        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                          minRating === rating
                            ? 'bg-amber-600 text-white'
                            : 'bg-white border border-gray-300 text-gray-700 hover:bg-amber-50'
                        }`}
                      >
                        {rating === 0 ? 'Toutes' : `${rating}+`}
                        {rating > 0 && <Star size={14} className="inline ml-1 fill-current" />}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* Quick Price Filters */}
              <div className="mt-6 pt-6 border-t border-gray-200">
                <label className="block text-sm font-semibold text-gray-700 mb-3">Prix rapide:</label>
                <div className="flex flex-wrap gap-2">
                  <button
                    onClick={() => {
                      setPriceRange('all');
                      setMinPrice(0);
                      setMaxPrice(1000);
                    }}
                    className={`px-4 py-2 rounded-lg transition-all text-sm ${
                      priceRange === 'all'
                        ? 'bg-amber-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-amber-50 border border-gray-200'
                    }`}
                  >
                    Tous
                  </button>
                  <button
                    onClick={() => {
                      setPriceRange('0-96.80');
                      setMinPrice(0);
                      setMaxPrice(96.80);
                    }}
                    className={`px-4 py-2 rounded-lg transition-all text-sm ${
                      priceRange === '0-96.80'
                        ? 'bg-amber-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-amber-50 border border-gray-200'
                    }`}
                  >
                    De 0 à 96.80 €
                  </button>
                  <button
                    onClick={() => {
                      setPriceRange('97.04-193.60');
                      setMinPrice(97.04);
                      setMaxPrice(193.60);
                    }}
                    className={`px-4 py-2 rounded-lg transition-all text-sm ${
                      priceRange === '97.04-193.60'
                        ? 'bg-amber-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-amber-50 border border-gray-200'
                    }`}
                  >
                    De 97.04 € à 193.60 €
                  </button>
                  <button
                    onClick={() => {
                      setPriceRange('193.84+');
                      setMinPrice(193.84);
                      setMaxPrice(1000);
                    }}
                    className={`px-4 py-2 rounded-lg transition-all text-sm ${
                      priceRange === '193.84+'
                        ? 'bg-amber-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-amber-50 border border-gray-200'
                    }`}
                  >
                    + de 193.84 €
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Results count */}
          <div className="pt-4 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              {searchQuery ? (
                <>
                  <strong>{filteredActivities.length}</strong> résultat{filteredActivities.length > 1 ? 's' : ''} pour "<strong className="text-amber-600">{searchQuery}</strong>"
                </>
              ) : (
                <>
                  <strong>{filteredActivities.length}</strong> activité{filteredActivities.length > 1 ? 's' : ''} trouvée{filteredActivities.length > 1 ? 's' : ''}
                </>
              )}
            </p>
          </div>
        </div>
      </section>

      {/* Activities Grid/List */}
      <section className="py-12 flex-grow">
        <div className="max-w-7xl mx-auto px-4">
          {sortedActivities.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-gray-500 text-xl">Aucune activité trouvée pour cette catégorie.</p>
            </div>
          ) : viewMode === 'grid' ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {sortedActivities.map((activity) => (
                <ActivityCard key={activity.id} activity={activity} favorites={favorites} onToggleFavorite={toggleFavorite} />
              ))}
            </div>
          ) : (
            <div className="space-y-6">
              {sortedActivities.map((activity) => (
                <ActivityListItem key={activity.id} activity={activity} favorites={favorites} onToggleFavorite={toggleFavorite} />
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}

function ActivityCard({ activity, favorites, onToggleFavorite }: { activity: Activity; favorites: number[]; onToggleFavorite: (id: number) => void }) {
  return (
    <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group">
      <div className="relative overflow-hidden">
        <img
          src={activity.image}
          alt={activity.title}
          className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
        />
        
        <div className="absolute top-4 left-4 flex flex-col gap-2">
          <span className="bg-amber-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
            {activity.badge}
          </span>
          {activity.urgent && (
            <span className="bg-red-500 text-white px-3 py-1 rounded-full text-xs font-medium animate-pulse">
              {activity.urgent}
            </span>
          )}
        </div>
        
        <button
          onClick={() => onToggleFavorite(activity.id)}
          className="absolute top-4 right-4 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors"
        >
          <Heart 
            size={20} 
            className={favorites.includes(activity.id) ? 'text-red-500 fill-current' : 'text-gray-600'} 
          />
        </button>
        
        <div className="absolute bottom-4 right-4 bg-white/95 backdrop-blur-sm rounded-lg px-3 py-2">
          <div className="text-right">
            <div className="text-lg font-bold text-amber-600">€{activity.price}</div>
            <div className="text-sm text-gray-500 line-through">€{activity.originalPrice}</div>
          </div>
        </div>
      </div>

      <div className="p-6">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-1">
            <Star className="text-amber-400 fill-current" size={16} />
            <span className="font-semibold text-gray-900">{activity.rating}</span>
            <span className="text-gray-500 text-sm">({activity.reviews} avis)</span>
          </div>
          <div className="flex items-center text-gray-500 text-sm">
            <MapPin size={14} className="mr-1" />
            {activity.location}
          </div>
        </div>

        <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-amber-600 transition-colors">
          {activity.title}
        </h3>

        <div className="flex items-center justify-between text-sm text-gray-600 mb-4">
          <div className="flex items-center">
            <Clock size={14} className="mr-1" />
            {activity.duration}
          </div>
          <div className="flex items-center">
            <Users size={14} className="mr-1" />
            {activity.groupSize}
          </div>
        </div>

        <div className="mb-6">
          <div className="flex flex-wrap gap-1">
            {activity.highlights.slice(0, 2).map((highlight, index) => (
              <span key={index} className="bg-amber-50 text-amber-700 px-2 py-1 rounded text-xs">
                ✓ {highlight}
              </span>
            ))}
            {activity.highlights.length > 2 && (
              <span className="text-amber-600 text-xs font-medium">
                +{activity.highlights.length - 2} autres
              </span>
            )}
          </div>
        </div>

        <div className="flex gap-3">
          <Button className="flex-1 text-sm py-2">
            Réserver maintenant
          </Button>
          <button className="px-4 py-2 border border-gray-200 rounded-lg hover:border-amber-600 hover:text-amber-600 transition-colors text-sm">
            Détails
          </button>
        </div>
      </div>
    </div>
  );
}

function ActivityListItem({ activity, favorites, onToggleFavorite }: { activity: Activity; favorites: number[]; onToggleFavorite: (id: number) => void }) {
  return (
    <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">
      <div className="flex flex-col md:flex-row">
        <div className="relative w-full md:w-80 h-64 md:h-auto flex-shrink-0 overflow-hidden">
          <img
            src={activity.image}
            alt={activity.title}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
          <div className="absolute top-4 left-4">
            <span className="bg-amber-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
              {activity.badge}
            </span>
          </div>
          <button
            onClick={() => onToggleFavorite(activity.id)}
            className="absolute top-4 right-4 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors"
          >
            <Heart 
              size={20} 
              className={favorites.includes(activity.id) ? 'text-red-500 fill-current' : 'text-gray-600'} 
            />
          </button>
        </div>

        <div className="flex-1 p-6 flex flex-col justify-between">
          <div>
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center space-x-1">
                <Star className="text-amber-400 fill-current" size={16} />
                <span className="font-semibold text-gray-900">{activity.rating}</span>
                <span className="text-gray-500 text-sm">({activity.reviews} avis)</span>
              </div>
              <div className="flex items-center text-gray-500 text-sm">
                <MapPin size={14} className="mr-1" />
                {activity.location}
              </div>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-amber-600 transition-colors">
              {activity.title}
            </h3>

            <div className="flex items-center gap-4 text-sm text-gray-600 mb-4">
              <div className="flex items-center">
                <Clock size={14} className="mr-1" />
                {activity.duration}
              </div>
              <div className="flex items-center">
                <Users size={14} className="mr-1" />
                {activity.groupSize}
              </div>
            </div>

            <div className="mb-4">
              <div className="flex flex-wrap gap-2">
                {activity.highlights.map((highlight, index) => (
                  <span key={index} className="bg-amber-50 text-amber-700 px-3 py-1 rounded text-sm">
                    ✓ {highlight}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between pt-4 border-t border-gray-200">
            <div>
              <div className="text-2xl font-bold text-amber-600">€{activity.price}</div>
              <div className="text-sm text-gray-500 line-through">€{activity.originalPrice}</div>
            </div>
            <div className="flex gap-3">
              <Button className="text-sm py-2 px-6">
                Réserver maintenant
              </Button>
              <button className="px-4 py-2 border border-gray-200 rounded-lg hover:border-amber-600 hover:text-amber-600 transition-colors text-sm">
                Détails
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

